// The eight risk assessment hazards and their plain-English labels, for the OFFICE form that adds a risk assessment to a
// completed record after the visit (Session ASW, Director decision D10). The server's view labels the flagged hazards
// with the same words (HAZARD_LABELS, server/src/modules/jobsheets/jobsheets.ts), which is what lets the office form
// read an existing entry back into ticks; riskAssessmentHazards.test.ts holds the two lists equal. The engineer's
// phone carries its own copy in JobDetail.tsx, pinned by the same test.
export const RISK_ASSESSMENT_HAZARDS: ReadonlyArray<{ key: string; label: string }> = [
  { key: "hazardElectrical", label: "Electrical" },
  { key: "hazardFalling", label: "Working at height / falling" },
  { key: "hazardTrapped", label: "Entrapment / moving parts" },
  { key: "hazardManualHandling", label: "Manual handling" },
  { key: "hazardSlip", label: "Slips, trips and falls" },
  { key: "hazardPublic", label: "Public / occupied area" },
  { key: "hazardConfined", label: "Confined space" },
  { key: "hazardNoise", label: "Noise" },
];

// The client copy of the server's one rule (validateRiskAssessment): control measures are required once any hazard,
// or a free-text other hazard, is flagged. The server enforces it too; this only saves a round trip.
export function riskAssessmentFormError(hazards: Record<string, boolean>, other: string, control: string): string | null {
  const anyHazard = RISK_ASSESSMENT_HAZARDS.some((h) => hazards[h.key]) || other.trim().length > 0;
  if (anyHazard && !control.trim()) return "Enter the control measures for the hazards you have identified.";
  if (!anyHazard && !control.trim()) return "Tick the hazards present, or record the control measures, before saving.";
  return null;
}
